import React from "react";
import { Tooltip, withStyles } from "@material-ui/core";

function TootipBase({ children, classes, arrow, ...props }) {
  return (
    <Tooltip classes={{ tooltip: classes.tooltip }} {...props}>
      {children}
    </Tooltip>
  );
}

const styles = () => ({
  tooltip: {
    padding: "8px 12px",
    borderRadius: "4px",
    backgroundColor: "rgba(0,0,0,0.87)",
    fontFamily: "Roboto",
    fontSize: "12px",
  },
});

export const CustomTooltip = withStyles(styles)(TootipBase);
